module.exports = __webpack_public_path__ + "img/vip.933896f7.png";